import React from 'react';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { news } from '../../mock/data';
import { Cloud, Leaf, Star, Bird } from './Decor';
import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';

const News = () => {
  const { data } = useQuery({ queryKey: ['public-announcements'], queryFn: () => api.get('/announcements').then((r) => r.data), retry: false });
  const remote = Array.isArray(data) ? data : [];
  const items = remote.length ? remote.slice(0, 3).map((item) => ({
    date: item.starts_at ? new Date(item.starts_at).toLocaleDateString('id-ID') : 'Info Sekolah',
    tag: item.display_type || 'Pengumuman', title: item.title,
    img: news[0]?.img, link: item.link_url || '#',
  })) : news;
  return (
    <section id="berita" className="relative overflow-hidden pt-24 pb-32 bg-sky-soft">
      <div className="absolute inset-0 pointer-events-none">
        <Cloud size={220} className="absolute top-10 left-[-30px] animate-cloud" />
        <Cloud size={200} className="absolute top-24 right-[-20px] animate-cloud-rev" />
        <Leaf size={64} className="absolute top-[35%] right-[5%] animate-float" />
        <Star size={26} className="absolute top-16 left-[18%] animate-twinkle" color="#ffb27a" />
        <div className="absolute bottom-16 left-[5%] animate-bird"><Bird size={70} /></div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="font-hand text-[15px] tracking-[0.35em] text-[#c74a2a] mb-2">BERITA & KEGIATAN</div>
            <h2 className="font-brush text-[46px] md:text-[64px] leading-[1] text-[#2b8b98]">
              Kabar Terbaru Sekolah
            </h2>
          </div>
          <button className="self-start md:self-auto inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2a2a2a] text-white font-hand text-[15px] hover:bg-[#3a3a3a] transition-colors">
            Semua Berita <ArrowRight size={16} />
          </button>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((n, i) => (
            <a
              key={i}
              href={n.link || '#'}
              className="group block bg-white rounded-[28px] overflow-hidden border-4 border-white shadow-[0_10px_0_rgba(120,180,200,0.25)] hover:-translate-y-2 transition-transform duration-500"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={n.img}
                  alt={n.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[#ee7a3d] text-white font-hand text-[13px]">
                  {n.tag}
                </div>
              </div>
              <div className="p-6">
                <div className="inline-flex items-center gap-1 font-hand text-[13px] text-[#3aa9b7]">
                  <CalendarDays size={14} /> {n.date}
                </div>
                <h3 className="mt-2 font-brush text-[24px] leading-tight text-[#3a2a1a] group-hover:text-[#c74a2a] transition-colors">
                  {n.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
